module.exports = __webpack_public_path__ + "img/arrow-up-circle.18b2cec8.svg";